// src/common/pages/PasswordResetConfirmPage.js
import React from "react";
import PasswordResetConfirm from "../containers/Auth/PasswordResetConfirm";

export default function PasswordResetConfirmPage() {
  return <PasswordResetConfirm />;
}
